import { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useLanguage } from '../hooks/useLanguage';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import VideoPlayer from '../components/VideoPlayer';
import PurchaseForm from '../components/PurchaseForm';

export default function Inscription() {
  const { t, isRTL } = useLanguage();
  const location = useLocation();
  const videoSrc = `${process.env.PUBLIC_URL || ''}/youshop.mp4`;

  useEffect(() => {
    // Always scroll to the form on load. Use a longer delay on mobile to
    // ensure the layout is fully painted (images, fonts, navbar) before
    // calculating the scroll offset.
    const scrollToForm = () => {
      const el = document.getElementById('get-started');
      if (el) {
        const navbarHeight = 80; // fixed navbar height
        const y = el.getBoundingClientRect().top + window.pageYOffset - navbarHeight;
        window.scrollTo({ top: y, behavior: 'smooth' });
      }
    };
    const timer = setTimeout(scrollToForm, 600);
    return () => clearTimeout(timer);
  }, [location]);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Header */}
      <section className="section-padding relative overflow-hidden bg-navy-900 pt-32">
        {/* decorative glows */}
        <div className="pointer-events-none absolute -top-24 -right-24 h-96 w-96 rounded-full bg-brand-500/20 blur-3xl" />
        <div className="pointer-events-none absolute -bottom-32 -left-24 h-96 w-96 rounded-full bg-brand-500/10 blur-3xl" />

        <div className="relative mx-auto max-w-5xl text-center">
          <Link
            to="/home"
            className="mb-8 inline-flex items-center gap-2 text-sm font-medium text-navy-200 transition-colors hover:text-white"
          >
            <svg
              className={`h-4 w-4 ${isRTL ? 'rotate-180' : ''}`}
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              viewBox="0 0 24 24"
            >
              <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" />
            </svg>
            {t('inscription.back')}
          </Link>

          <span className="inline-block rounded-full border border-brand-500/40 bg-brand-500/10 px-4 py-1.5 text-sm font-semibold tracking-wider text-brand-400">
            {t('inscription.badge')}
          </span>
          <h1 className="mt-6 text-4xl font-bold text-white sm:text-5xl lg:text-6xl">
            {t('inscription.title')}{' '}
            <span className="text-brand-500">{t('inscription.titleHighlight')}</span>
          </h1>
          <p className="mx-auto mt-6 max-w-2xl text-lg text-navy-200">
            {t('inscription.subtitle')}
          </p>
        </div>
      </section>

      {/* Registration form */}
      <PurchaseForm />

      {/* Custom video player */}
      <section className="section-padding bg-navy-900 relative overflow-hidden">
        <div className="pointer-events-none absolute -top-24 -left-24 h-96 w-96 rounded-full bg-brand-500/10 blur-3xl" />
        <div className="relative mx-auto max-w-4xl">
          <VideoPlayer src={videoSrc} />
        </div>
      </section>

      <Footer />
    </div>
  );
}
